module.exports = __webpack_public_path__ + "static/no-webcam-filler-b1de3f318a3a3b27840d33d1afc08f00.webp";